<template>
  <ModalForm
    v-model="formData"
    title="Укажите общий вес"
    text-btn-confirm="Сохранить"
    btn-size="100"
    class="modal--md"
    @request="onRequest"
    @reject="onReject"
  >
    <ConsignmentFormWeightDirty
      v-model="formData.reservedRows"
      class="mb-20"
      :position="position"
      :consignment="consignment"
      :qty="consignment.value"
    />
  </ModalForm>
</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm.vue'
import ConsignmentController from '@/controllers/production/Consignment/ConsignmentController'
import ConsignmentFormWeightDirty from '@/components/production/consignment/ConsignmentFormWeightDirty.vue'
import { mappedDirtyWeights, mappedParamsWeightWithLength, mappedReserveData } from '@/utils/production/consignment'

export default {
  name: 'ModalConsignmentSetWeightDirty',
  components: {
    ConsignmentFormWeightDirty,
    ModalForm
  },

  props: {
    consignment: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    reserveData: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      formData: {
        reservedRows: this.consignment?.dirty_weights?.length
          ? mappedDirtyWeights(this.consignment.dirty_weights)
          : mappedReserveData(this.reserveData)
      }
    }
  },

  methods: {
    async onRequest () {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')

        const params = mappedParamsWeightWithLength(this.formData.reservedRows)

        const response = await ConsignmentController.setWeightDirtyWithLength(this.consignment.id, params)
        if (response?.status !== 200) return

        this.$emit('setWeightDirty', response.data)
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },
    onReject () {
      this.$emit('reject')
    }
  }
}
</script>
